export default [
  {
    path: "/service-visits",
    name: "service-visits",
    component: () => import("@/modules/service-visits/ServiceVisits.vue"),
    children: [
      {
        path: "list",
        name: "list-service-visits",
        component: () =>
          import("@/modules/service-visits/pages/ServiceVisitsList.vue"),
        meta: { permissions: ["service-visits-show", "mechanic"] }
      },
      {
        path: "board",
        name: "board-service-visits",
        component: () =>
          import("@/modules/service-visits/pages/ServiceVisitsBoard.vue"),
        meta: { permissions: ["service-visits-show", "mechanic"] }
      },
      {
        path: "calendar",
        name: "calendar-service-visits",
        component: () =>
          import("@/modules/service-visits/pages/ServiceVisitsCalendar.vue"),
        meta: { permissions: ["service-visits-show", "mechanic"] }
      },
      {
        path: "add",
        name: "add-service-visits",
        component: () =>
          import("@/modules/service-visits/pages/ServiceVisitsAdd.vue"),
        meta: { permissions: ["service-visits-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-service-visits",
        component: () =>
          import("@/modules/service-visits/pages/ServiceVisitsEdit.vue"),
        meta: { permissions: ["service-visits-update"] }
      },
      {
        path: "show/:id",
        name: "show-service-visits",
        component: () =>
          import("@/modules/service-visits/pages/ServiceVisitsShow.vue"),
        meta: { permissions: ["service-visits-show", "mechanic"] }
      }
    ]
  }
];
